module.exports = __webpack_public_path__ + "img/sample-medicare-card-part-b.303dc1c.png";